module.exports = __webpack_public_path__ + "media/hero-mob.9b9d0da2.mp4";